import {Component} from 'react';
import h from 'react-hyperscript';
import './Settings.scss';
import {h3, h4, p, footnote} from 'Components/Typography/Typography';
import content from 'Assets/data/settings.json';
import globals from 'Assets/data/globals.json';
import gsuite from 'Assets/data/gsuite.json';
import FourCs from './FourCs/FourCs';
import Button from 'Components/Buttons/Buttons';
import InputGroup from 'Components/Form/Input';
import BasicCard from 'Components/Cards/BasicCard';
import {ENDPOINTS, getAccessToken} from 'Src/utils/utils';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import {eyebrow} from 'Components/Typography/Typography';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import Snackbar from '@material-ui/core/Snackbar';
import {InputAdornment} from '@material-ui/core';
import Event from '@material-ui/icons/Event';
import IconButton from '@material-ui/core/IconButton';
import {DatePicker, MuiPickersUtilsProvider}
  from '@material-ui/pickers';

const inputMin = 1;
const inputMax = 2147483647;
const inputMaxLength = 9;
const productWindowLength = 12;
class Settings extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      num_teachers: this.props.userStatus.num_teachers || 1000,
      num_students: this.props.userStatus.num_teachers || 5000,
      collaboration: ['forms', 'sheets'],
      communication: ['meet', 'gmail', 'calendar', 'drive'],
      creativity: ['docs', 'slides', 'sites', 'drawings'],
      critical_thinking: ['classroom'],
      collaboration_remaining: [],
      communication_remaining: [],
      creativity_remaining: [],
      critical_thinking_remaining: [],
      isLoaded: false,
      hasError: false,
      snackbarOpen: false,
      hasUserInteracted: false,
      isReportPage: false,
      currentStartDate: moment(this.props.userStatus
          .current_product_metrics_date),
      prevStartDate: moment(this.props.userStatus
          .previous_product_metrics_date),
      reportAvailDate: this.props.userStatus.dates.report_available_date,
      currentPeriodMessage: 'Please select another start date. ' +
        'Your start date must not be earlier than 6 months ' +
        'ago, and the last day of your 12-week period must ' +
        'not be later than 5 days ago. ',
      previousPeriodMessage: 'Please select another start date. ' +
        'Your start date must not be earlier than 24 months ago, ' +
        'and your comparison 12-week period must not overlap ' +
        'with your recent 12-week period.',
      productWindowsChanged: false,
    };
    this.removeFromBucket = this.removeFromBucket.bind(this);
    this.addToBucket = this.addToBucket.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkIfCanSubmit = this.checkIfCanSubmit.bind(this);
    this.handleSnackbarClose = this.handleSnackbarClose.bind(this);
    this.handleRemoveFromBucket = this.handleRemoveFromBucket.bind(this);
    this.handleAddToBucket = this.handleAddToBucket.bind(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.getDistrictInfo();

    if (window.location.href.includes('/reports/')) {
      this.setIsReportPage(true);
    }

    // Sends default product window dates
    if (this.props.saveRequired) {
      const primaryDate = this.state.currentStartDate.format('YYYY-MM-DD');
      const secondaryDate = this.state.prevStartDate.format('YYYY-MM-DD');
      const data = {
        access_token: getAccessToken(this.props.googleUser),
        primary_date: primaryDate,
        secondary_date: secondaryDate,
        district_id: window.localStorage.getItem('districtId'),
        primary_domain: window.localStorage.getItem('primaryDomain'),
        rcd_id: window.localStorage.getItem('rcdId'),
        survey_id: window.localStorage.getItem('surveyId'),
      };
      this.setProductDataWindow(data);
    }
  }

  setHasError(value) {
    this.setState({
      hasError: value,
    }, () => {
      if (value === true) {
        this.props.setAllowModalClose(value);
      }
    });
  }

  setIsReportPage(value) {
    this.setState({
      isReportPage: value,
    });
  }

  setCurrentStartDate(value) {
    this.setState({
      currentStartDate: value,
    });
  }

  setPrevStartDate(value) {
    this.setState({
      prevStartDate: value,
    });
  }

  adjustRemainingProduts() {
    content.four_cs.skills.forEach((bucket) => {
      const id = bucket.toLowerCase().replace(' ', '_');
      this.setRemainingProducts(id);
    });
  }

  getDistrictInfo() {
    fetch(ENDPOINTS.USER_STATUS, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.props.googleUser.getAuthResponse().id_token,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify({
        access_token: getAccessToken(this.props.googleUser),
      }),
    })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            return {'hasError': 'true'};
          }
        })
        .then((result) => {
          if (result.hasError) {
            this.setIsLoaded(true);
            this.setHasError(true);
          } else if (result.four_c_config) {
            this.setHasError(false);
            this.setValues(result);
          } else {
            this.setHasError(false);
            this.setValues({
              num_teachers: this.props.userStatus.num_teachers || inputMin,
              num_students: this.props.userStatus.num_students || inputMin,
              collaboration: this.state.collaboration,
              communication: this.state.communication,
              creativity: this.state.creativity,
              critical_thinking: this.state.critical_thinking,
            });
          }
        }, (error) => {
          console.error('No result', error);
        });
  }

  setValues(data) {
    if (this._isMounted) {
      let parsedData;
      let stateObj;

      if (data.four_c_config) {
        parsedData = JSON.parse(data.four_c_config);
      }

      if (typeof parsedData === 'object') {
        stateObj = {
          num_teachers: data.num_teachers,
          num_students: data.num_students,
          collaboration: parsedData.collaboration,
          communication: parsedData.communication,
          creativity: parsedData.creativity,
          critical_thinking: parsedData.critical_thinking,
        };
      } else {
        stateObj = data;
      }

      this.setState(stateObj, () => {
        this.checkIfCanSubmit(false);
        this.adjustRemainingProduts();
        this.setIsLoaded(true);
      });
    }
  }

  setIsLoaded(value) {
    if (this._isMounted) {
      this.setState({
        isLoaded: value,
      });
    }
  }

  sendSettingsData(closeAfterSubmit) {
    this.props.setProductWindowsLoading(true);
    const primaryDate = this.state.currentStartDate.format('YYYY-MM-DD');
    const secondaryDate = this.state.prevStartDate.format('YYYY-MM-DD');
    const data = {
      num_teachers: this.state.num_teachers,
      num_students: this.state.num_students,
      four_c_config: {
        collaboration: this.state.collaboration,
        communication: this.state.communication,
        creativity: this.state.creativity,
        critical_thinking: this.state.critical_thinking,
      },
    };
    this.props.userStatus.current_product_metrics_date = primaryDate;
    this.props.userStatus.previous_product_metrics_date = secondaryDate;
    this.props.userStatus.num_students = this.state.num_students;
    this.props.userStatus.num_teachers = this.state.num_teachers;
    fetch(ENDPOINTS.SET_SETTINGS, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.props.googleUser.getAuthResponse().id_token,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify(data),
    })
        .then((response) => response.json())
        .then((result) => {
          // Waits 2 seconds before setting the loading of product windows
          setTimeout(() => this.props.setProductWindowsLoading(false), 2000);
          if (result.success) {
            this.setIsSaved(true);
            this.handleSnackbarOpen();
          } else {
            this.setIsSaved(false);
          }
        }, (error) => {
          this.props.setProductWindowsLoading(false);
          this.setIsSaved(false);
        });

    if (closeAfterSubmit) {
      this.props.handleSettingsClose();
    }
  }

  handleInputChange(e, stateId) {
    const value = e.currentTarget.value;
    const valueString = value.length > inputMaxLength ?
      value.substring(value.length - 1, value.length - (inputMaxLength + 1)) :
      value;
    let number = value ? parseInt(valueString) : 0;
    number = Math.min(Math.max(number, inputMin), inputMax);
    this.checkIfCanSubmit(false);

    this.setState({
      [stateId]: number,
    });
  }

  checkIfCanSubmit(doSubmit) {
    const students = this.state.num_students;
    const teachers = this.state.num_teachers;

    if (this.state.isReportPage) {
      this.props.setAllowModalClose(true);
    }

    if (students < 1 || teachers < 1) {
      this.props.setAllowModalClose(false);
    } else {
      this.props.setAllowModalClose(true);

      if (doSubmit) {
        this.handleSubmit();
      }
    }
  }

  setIsSaved(value) {
    this.setState({
      isSaved: value,
    }, () => {
      this.props.setAllowModalClose(true);
    });
  }

  removeFromBucket(e) {
    e.preventDefault();
    const bucket = e.currentTarget.getAttribute('databucket');
    const target = e.currentTarget.getAttribute('dataproduct');
    const newArray = this.state[bucket];
    const index = newArray.indexOf(target);
    if (index > -1) {
      newArray.splice(index, 1);
    }
    this.setState({
      [bucket]: newArray,
    }, () => {
      this.setRemainingProducts(bucket);
    });
  }

  addToBucket(e) {
    e.preventDefault();
    const bucket = e.currentTarget.getAttribute('databucket');
    const target = e.currentTarget.getAttribute('dataproduct');
    const newArray = this.state[bucket];

    newArray.push(target);

    this.setState({
      [bucket]: newArray,
    }, () => {
      this.setRemainingProducts(bucket);
    });
  }

  setRemainingProducts(bucket) {
    const remaining = this.getRemainingProducts(bucket);
    this.setState({
      [`${bucket}_remaining`]: remaining,
    }, () => {
      if (this.state.hasUserInteracted && !this.state.isReportPage) {
        this.checkIfCanSubmit(true);
      }
    });
  }

  formatDataWindow(startDate) {
    const endDate = moment(startDate).add(
        productWindowLength, 'weeks');
    const formattedStart = startDate.format('MM/DD/YYYY');
    const formattedEnd = endDate.format('MM/DD/YYYY');
    return (formattedStart + ' - ' + formattedEnd);
  };

  getRemainingProducts(bucket) {
    const products = [...gsuite.productIds];
    this.state[bucket].forEach((prod) => {
      const index = products.indexOf(prod);
      if (index > -1) {
        products.splice(index, 1);
      }
    });
    return products;
  }

  handleSubmit(closeAfterSubmit) {
    this.sendSettingsData(closeAfterSubmit);
  }

  handleSnackbarClose() {
    this.setState({snackbarOpen: false});
  }

  handleSnackbarOpen() {
    this.setState({snackbarOpen: true});
  }

  handleRemoveFromBucket(e) {
    if (!this.state.hasUserInteracted) {
      this.setHasUserInteracted(true);
    }
    this.removeFromBucket(e);
  }

  handleAddToBucket(e) {
    if (!this.state.hasUserInteracted) {
      this.setHasUserInteracted(true);
    }
    this.addToBucket(e);
  }

  handleUnsavedClose() {
    if (this.props.saveRequired) {
      return;
    }
    // Only resets product windows if changed by the user
    if (!this.state.productWindowsChanged) {
      return this.props.handleSettingsClose();
    }
    const primaryDate = this.props.userStatus.current_product_metrics_date;
    const secondaryDate = this.props.userStatus.previous_product_metrics_date;
    const data = {
      access_token: getAccessToken(this.props.googleUser),
      primary_date: primaryDate,
      secondary_date: secondaryDate,
      district_id: window.localStorage.getItem('districtId'),
      primary_domain: window.localStorage.getItem('primaryDomain'),
      rcd_id: window.localStorage.getItem('rcdId'),
      survey_id: window.localStorage.getItem('surveyId'),
    };
    this.setProductDataWindow(data);
    this.props.handleSettingsClose();
  }

  handlePrimaryWindowDateChange(date) {
    this.setCurrentStartDate(date);
    // Only updates on DB on Report Overview and on the latest report
    // with open survey
    if (!this.state.isReportPage ||
      this.props.onLatestReport) {
      const primaryDate = date.format('YYYY-MM-DD');
      const data = {
        access_token: getAccessToken(this.props.googleUser),
        primary_date: primaryDate,
        district_id: window.localStorage.getItem('districtId'),
        primary_domain: window.localStorage.getItem('primaryDomain'),
        rcd_id: window.localStorage.getItem('rcdId'),
        survey_id: window.localStorage.getItem('surveyId'),
      };
      this.setProductDataWindow(data);
    }
  }

  handlePreviousWindowDateChange(date) {
    this.setPrevStartDate(date);
    // Only updates on DB on Report Overview and on the latest report
    // with open survey
    if (!this.state.isReportPage ||
      this.props.onLatestReport) {
      const secondaryDate = date.format('YYYY-MM-DD');
      const data = {
        access_token: getAccessToken(this.props.googleUser),
        secondary_date: secondaryDate,
        district_id: window.localStorage.getItem('districtId'),
        primary_domain: window.localStorage.getItem('primaryDomain'),
        rcd_id: window.localStorage.getItem('rcdId'),
        survey_id: window.localStorage.getItem('surveyId'),
      };
      this.setProductDataWindow(data);
    }
  }

  setProductDataWindow(data) {
    this.setProductWindowsChanged(true);
    fetch(ENDPOINTS.SET_PRODUCT_METRICS_WINDOW, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.props.googleUser.getAuthResponse().id_token,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify(data),
    })
        .then((response) => response.json())
        .then((result) => {
          if (result.success) {
            this.setIsSaved(true);
          } else {
            this.setIsSaved(false);
          }
        }, (error) => {
          this.setIsSaved(false);
        });
  }

  setHasUserInteracted(value) {
    this.setState({
      hasUserInteracted: value,
    });
  }

  setProductWindowsChanged(value) {
    this.setState({
      productWindowsChanged: value,
    });
  }

  sanitize(string) {
    return string.replace('{{survey_name}}', this.props.currentReportName);
  }

  render() {
    const reportLockedIn = !this.props.userStatus.survey_open_period_flag;
    if (this.state.isLoaded) {
      if (this.state.hasError) {
        return (
          h('div', {
            id: 'settings',
            className: 'settings__container is-loaded',
          }, h(BasicCard, {
            className: 'settings__inner',
          }, [
            h('span', {
              id: 'close-settings',
              className: `material-icons text--grey`,
              onClick: () => {
                this.props.handleUnsavedClose();
              },
            }, 'close'),
            globals.errors.fetch,
          ])
          )
        );
      } else {
        return ([
          h('div', {
            className: 'settings-background',
            onClick: () => this.handleUnsavedClose(),
          }, null),

          h('div', {
            id: 'settings',
            className: 'settings__container is-loaded',
          }, [h(BasicCard, {
            className: 'settings__inner',
          }, [

              this.props.modalId === 'primary' && !this.props.saveRequired ?
                h('span', {
                  id: 'close-settings',
                  className: `${this.props.allowModalClose ?
                    'material-icons text--grey' :
                    'material-icons text--grey disabled'
                  }`,
                  onClick: () => this.handleUnsavedClose(),
                }, 'close') : null,

              h(h3, {
                key: 'settings-title',
                className: 'settings__title',
              }, this.props.modalId === 'primary' ?
                content.title :
                content.title_alt
              ),

              this.props.modalId === 'primary' ? h(p, {
                key: 'settings-desc',
                className: 'settings__desc text--grey',
                dangerouslySetInnerHTML: content.desc,
              }) : h('div', null, [
                h(p, {
                  key: 'settings-desc',
                  className: 'text--grey',
                }, [
                  content.desc_alt.partOne,
                  h('b', null, content.desc_alt.bold),
                  content.desc_alt.partTwo,
                ]),
                h(p, {
                  key: 'settings-desc-2',
                  className: 'padding-top--sm text--grey',
                }, content.desc_alt.list.title),
                h('ol', {
                  className: 'padding-bottom--md',
                }, [
                  h('li', {
                    className: 'text--grey',
                  }, [
                    content.desc_alt.list.items[0].partOne,
                    h('b', null, content.desc_alt.list.items[0].bold),
                    content.desc_alt.list.items[0].partTwo,
                  ]),
                  h('li', {
                    className: 'text--grey',
                  }, content.desc_alt.list.items[1]),
                ]),
              ]),

              h('div', {
                key: 'settings-form',
              }, [
                h(h4, {
                  key: 'settings-form-title',
                }, `${this.props.userStatus.district_name}'s Information`),

                h('div', {
                  key: 'settings-form-fields',
                  className: 'flex flex--space-between flex--wrap',
                }, content.fields.map((field, i) => {
                  const stateId = field.id.replace('-', '_');
                  return (
                    h(InputGroup, {
                      key: field.id,
                      id: field.id,
                      name: field.id,
                      label: field.title,
                      tooltip: this.props.modalId === 'primary' ?
                          field.tooltip : field.tooltip_alt,
                      type: 'number',
                      min: inputMin,
                      max: inputMax,
                      minLength: 1,
                      maxLength: inputMaxLength,
                      onClick: () => {
                        this.setState({hasUserInteracted: true});
                      },
                      onChange: (e) => {
                        this.handleInputChange(e, stateId);
                      },
                      defaultValue: this.state[stateId],
                    }, null)
                  );
                })
                ),
              ]),

              this.props.isAdmin ? h('div', {className: 'settings-pdw'}, [
                h(h4, {
                  key: 'settings-product-data-window-title',
                  className: 'settings-pdw__title',
                }, content.pdw.title),

                h(p, {
                  key: 'settings-desc',
                  className: 'settings-pdw__desc text--grey',
                  dangerouslySetInnerHTML: content.pdw.desc,
                }),

                h(MuiPickersUtilsProvider, {
                  utils: MomentUtils,
                }, h('div', {className: 'settings-pdw-container'}, [
                  h('div', {className: 'settings-date-field'}, [
                    h(TooltipGroup, {
                      title: content.pdw.currentPeriod.tooltip,
                    }, h(eyebrow, {
                      className:
                        'date_field_eyebrow',
                    }, content.pdw.currentPeriod.fieldName)),
                    h(
                        DatePicker,
                        {
                          disableToolbar: 'true',
                          className: 'update-pdw__datepicker',
                          key: 'current-period__datepicker',
                          variant: 'inline',
                          inputVariant: 'filled',
                          disabled:
                            (this.state.isReportPage &&
                              !this.props.onLatestReport) || reportLockedIn,
                          autoOk: true,
                          minDate: moment.max(
                              moment(this.state.prevStartDate)
                                  .subtract(productWindowLength,
                                      'weeks'),
                              moment().subtract(6, 'months')
                          ),
                          minDateMessage: this.state.currentPeriodMessage,
                          maxDate: moment(new Date())
                              .subtract(productWindowLength, 'weeks')
                              .subtract(5, 'days'),
                          maxDateMessage: this.state.currentPeriodMessage,
                          InputProps: {
                            endAdornment: h(InputAdornment, {position: 'end'}, [
                              h(IconButton, {}, [
                                h(Event, {}),
                              ]),
                            ]),
                          },
                          label: 'Choose a start date',
                          labelFunc: this.formatDataWindow,
                          value: this.state.currentStartDate,
                          onChange:
                            (date) => this.handlePrimaryWindowDateChange(date),
                        },
                        null
                    ),
                  ]),

                  h('div', {className: 'settings-date-field'}, [
                    h(TooltipGroup, {
                      title: content.pdw.previousPeriod.tooltip,
                    }, h(eyebrow, {
                      className:
                        'date_field_eyebrow',
                    }, content.pdw.previousPeriod.fieldName)),
                    h(DatePicker, {
                      disableToolbar: 'true',
                      className: 'update-pdw__datepicker',
                      key: 'previous-period__datepicker',
                      variant: 'inline',
                      width: '100%',
                      inputVariant: 'filled',
                      disabled:
                        (this.state.isReportPage &&
                          !this.props.onLatestReport) || reportLockedIn,
                      autoOk: true,
                      minDate: moment().subtract(24, 'months'),
                      minDateMessage: this.state.previousPeriodMessage,
                      maxDate: moment(this.state.currentStartDate)
                          .subtract(productWindowLength, 'weeks'),
                      maxDateMessage: this.state.previousPeriodMessage,
                      InputProps: {
                        endAdornment: h(InputAdornment, {position: 'end'}, [
                          h(IconButton, {}, [
                            h(Event, {}),
                          ]),
                        ]),
                      },
                      label: 'Choose a start date',
                      labelFunc: this.formatDataWindow,
                      value: this.state.prevStartDate,
                      inputadornmentprops: {position: 'end'},
                      onChange:
                        (date) => this.handlePreviousWindowDateChange(date),
                    },
                    null
                    ),
                  ]),
                ])),
              ]) : null,

              h('div', {
                key: 'settings-four-cs',
                id: 'settings__four-cs',
              }, [
                h(TooltipGroup, {
                  title: content.four_cs.tooltip,
                }, h(h4, {
                  key: 'settings-four-cs-title',
                }, content.four_cs.title)),
                h(FourCs, {
                  key: 'settings-four-cs-component',
                  buckets: content.four_cs.skills,
                  products: gsuite.products,
                  handleRemoveFromBucket: this.handleRemoveFromBucket,
                  handleAddToBucket: this.handleAddToBucket,
                  activeBuckets: this.state,
                  handleSubmit: this.handleSubmit,
                }, null),
              ]),

              h('div', {
                key: 'settings-four-cs-button',
                className:
                  'flex--wrap-all flex--center settings__submit-container',
              }, [
                h(Button, {
                  to: '#',
                  type: 'basic',
                  noRedirect: true,
                  className:
                    `${(this.props.saveRequired &&
                      this.props.allowModalClose) ||
                      (this.props.allowModalClose &&
                      this.props.isAdmin &&
                      (!this.state.isReportPage ||
                        (this.props.onLatestReport && !reportLockedIn))) ?
                      'active' :
                      'button--disabled'} button--centered`,
                  onClick: (e) => {
                    this.handleSubmit(true);
                  },
                }, 'Save Settings'),

                this.state.isReportPage && (!this.state.onLatestReport ||
                  reportLockedIn) ? h(footnote, {
                    className: 'text--center text--grey padding-top--sm',
                  }, !this.props.onLatestReport ||
                    reportLockedIn ?
                      this.sanitize(globals.errors.cannotSubmit) :
                        null
                  ) : null,
              ]),
          ]),
            this.props.modalId === 'primary' ? h(Snackbar, {
              key: 'snackbar',
              open: this.state.snackbarOpen,
              onClose: this.handleSnackbarClose,
              contentprops: {'aria-describedby': 'settings-saved'},
              message: 'Saved',
            }, null) : null,
          ]),
        ]);
      }
    } else {
      return (
        h('div', {
          className: 'settings__container',
        }, h(BasicCard, {
          id: 'settings',
        }, h(LoadingIndicator, null, null)))
      );
    }
  }
}

export default Settings;
